export default function toLeafLetGeoForms(geoform) {
	geoform.coords = geoform.coords.map((coords) => {
		return {
			lat: coords[1],
			lng: coords[0],
		};
	});
	return geoform;
}
